import { render, staticRenderFns } from "./swiperVideoList.vue?vue&type=template&id=4a77f9bf&scoped=true"
import script from "./swiperVideoList.vue?vue&type=script&lang=js"
export * from "./swiperVideoList.vue?vue&type=script&lang=js"
import style0 from "./swiperVideoList.vue?vue&type=style&index=0&id=4a77f9bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77f9bf",
  null
  
)

export default component.exports